<template>
    <div class="beijin">

        <div v-show="noOpen" class='popContainer2' @click.stop="openNo()">
            <div v-show="noOpen" class='popContainer' >
                <!--<div>-->
                    <!--&lt;!&ndash;<div></div>&ndash;&gt;-->
                    <!--<img src="../assets/title.png" alt=""style="width: 100%;height: 10%">-->
                    <!--<div class="times">-->
                        <!--{{currentTime}}-->
                    <!--</div>-->
                <!--</div>-->
                <div class="shuru">
                    <img src="../assets/input.png" alt=""style="width: 50%;height: 30%;margin-left: 50%;margin-top: 6%;">
                    <div class="sousuo" @click.stop="accept()"></div>
                    <div  @click.stop="openTrue2()">
                        <!--<input type="text" v-model="password" placeholder="请输入登陆密码">-->
                        <input type="password" style="width: 200x;height: 20x;" v-model="password" placeholder="请输入登陆密码">
                    </div>
                </div>
                <p class="offOn" v-if="offOn" style="color: red;width: 100px;margin-left: 68%;font-size: 16px">{{offValue}}</p>
                <div class="mima">
                    <img src="../assets/shuru.png" alt=""style="width: 50%;height: 70%;margin-left: 50%;">
                    <div class="mimazi"  @click.stop="openTrue2()">
                        <div class="mimazi1"  @click.stop="mima('1')"></div>
                        <div class="mimazi2"  @click.stop="mima('2')"></div>
                        <div class="mimazi3"  @click.stop="mima('3')"></div>
                        <div class="mimazi4"  @click.stop="mima('4')"></div>
                        <div class="mimazi5"  @click.stop="mima('5')"></div>
                        <div class="mimazi6"  @click.stop="mima('6')"></div>
                        <div class="mimazi7"  @click.stop="mima('7')"></div>
                        <div class="mimazi8"  @click.stop="mima('8')"></div>
                        <div class="mimazi9"  @click.stop="mima('9')"></div>
                        <div class="mimazi0"  @click.stop="mima('0')"></div>
                        <div class="mimaziX"  @click.stop="mima('X')"></div>
                        <div class="mimaziqr"  @click.stop="mima('qr')"></div>
                    </div>
                </div>
            </div>
        </div>


        <video @click.stop="openTrue()"
                id="videoplay"
               src="../assets/suoping.mp4"
               loop="loop"
               autoplay="autoplay"
               muted
               poster="../assets/zhuye.png"
               width="1"
               height="1"
        ></video>
    </div>
</template>

<script>
	export default {
		name: "login",
        data(){

			return{
				offOn:true,
                offValue:'',
				timer: "",
				currentTime: '',
				visible: false,
				layout: "normal",
				input: null,
				options: {
					useKbEvents: false,
					preventClickEvent: false
				},
				noOpen:false,
				number:'',
				password:''
            }
        },

		methods: {
			openNo() {
				this.noOpen = false
				console.log('这是遮罩层')
				this.visible = false
                this.password = ''
			},
			openTrue() {
				this.noOpen = true
				console.log('这是视频')
                this.visible = false
				this.offOn=false
			},
			openTrue2() {
				this.noOpen = true
				console.log('这是输入框')
				this.visible = true
			},
            mima(value){
                if (value=='qr') {
	                if (this.password=='666666'){
		                this.$router.push('/navigation')
	                }else{
	                	this.password=''
                        this.offOn=true
	                	this.offValue='密码错误'
	                }
                }else {
                	this.password += value
                }
            },
			accept(text) {
				// alert("Input text: " + text);
                if (this.password=='') {
	                this.offValue='请输入密码'
	                this.offOn=true
                }else {
	                if (this.password=='666666'){
		                this.$router.push('/menu')
	                }else{
		                this.password=''
		                // alert("密码错误");
		                this.offOn=true
		                this.offValue='密码错误'
	                }
                }

				this.hide();
			},

			show(e) {
				this.input = e.target;
				this.layout = e.target.dataset.layout;

				if (!this.visible)
					this.visible = true
			},

			hide() {
				this.visible = false;
			}
		},
		created() {

        console.log("准备跳了")
        this.$router.push('/navigation')


			this.offValue=''
			var _this = this;
			_this.timer = setInterval(function() {
				_this.currentTime =
					new Date().getFullYear() +
					"-" +
					(new Date().getMonth() + 1) +
					"-" +
					new Date().getDate() +
					" " +
					new Date().getHours() +
					":" +
					new Date().getMinutes()
			}, 1000);
			console.log(_this.currentTime)
			// +
			// ": " +
			// new Date().getSeconds();
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		}
	}
</script>

<style scoped>
    .beijin{
        width: 100%;
        height: 100%;
        background: url("../assets/zhuye.png");
        background-size:cover;
    }

    #videoplay {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 5px;
        z-index: -5;
    }

    .popContainer{
        position: absolute;
        top: 20%;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0);
        width: 100%;
        height: 100%;
        color: cornsilk;
        z-index: 100;
    }
    .popContainer .times{
        position: absolute;
        top: 10%;
        left: 80%;
        right: 0;
        bottom: 0;
    }
    .popContainer2{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
                       width: 100%;
        height: 100%;
        z-index: 50;
    }
    .shuru{
        position: relative;
    }
    .shuru .sousuo{
        height: 22px;
        width: 30px;
        /*background-color: red;*/
        position: absolute;
        top: 70%;
        left: 68%;
        right: 0;
        bottom: 0;
    }
    .shuru input{
        text-align:center;
        height: 20px;
        width: 200px;
        background:none;
        color: #999999;
        border:none;
        outline:none;
        font-size: 20px;
        position: absolute;
        top: 71%;
        left: 70%;
        right: 0;
        bottom: 0;
        height: 260px;
        width: 282px;
        /*background-color: red;*/
        position: absolute;
        top: 30px;
        left: 68%;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    .mima .mimazi div{
        width: 92px;
        height: 63px;
        margin-top: 2px;
        margin-left: 1px;
        /*background-color: red;*/
        float: left;
}

    .mima{
        position: relative;
    }
    .mima .mimazi {

        height: 260px;
        width: 282px;
        position: absolute;
        top: 40px;
        left: 68%;
        right: 0;
        bottom: 0;
        overflow: hidden;


    }
</style>




// WEBPACK FOOTER //
// src/views/login.vue